export const GET_MENU_PERMISSION = 'CHANGE_MENU_PERMISSION';
export const UPDATE_MENU_PERMISSION = 'UPDATE_MENU_PERMISSION';
export const CHANGE_MENU_BOARD_THEME = 'CHANGE_MENU_BOARD_THEME';
export const CHANGE_MENU_BOARD_COUMN_HEADER = 'CHANGE_MENU_BOARD_COUMN_HEADER';
export const CHANGE_MENU_BOARD_STATE = 'CHANGE_MENU_BOARD_STATE';
export const BOARD_UPDATE_SHARED_MEMBERS = 'BOARD_UPDATE_SHARED_MEMBERS';

import {BoardTheme} from '../types/board.types';
interface GetMenuPermission
{
    type: typeof GET_MENU_PERMISSION,
    permissions: any 
}

interface UpdateMenuPermission
{
    type: typeof UPDATE_MENU_PERMISSION,
    permissions: any 
}


interface ChangeMenuBoardTheme
{
    type: typeof CHANGE_MENU_BOARD_THEME,
    theme: BoardTheme
}

interface ChangeMenuColumnHeader
{
    type: typeof CHANGE_MENU_BOARD_COUMN_HEADER,
    columnId: string,
    color: string
}

interface ChangeBoardMenuState
{
    type: typeof CHANGE_MENU_BOARD_STATE,
    actionType: string,
    columns: any,
    theme: any,
    boardType: any,
    appyToAllWs?: boolean
}

interface BoardUpdateSharedMembers
{
    type: typeof BOARD_UPDATE_SHARED_MEMBERS,
    data: any
}

export type MenuActionTypes = GetMenuPermission | UpdateMenuPermission | ChangeMenuBoardTheme | ChangeMenuColumnHeader | ChangeBoardMenuState | BoardUpdateSharedMembers;